<template>
  <div class="main">
    <div class="subject">
      <div>
        <a-input-search
          style="margin:8px 0"
          placeholder="输入关键词搜索"
          enterButton
          @search="onSerch"
        />
      </div>
      <a-table
        :columns="columns"
        :rowKey="record => record._id"
        :dataSource="lists"
        :pagination="pagination"
        :loading="loading"
        size="small"
        @change="handleTableChange"
      >
        <template slot="title">
          <a-select
            style="width: 200px"
            :value="param.wxSiteId"
            @change="headChange"
          >
            <a-select-option v-for="item in headSiteList" :key="item.siteid">
              {{ item.sitename }}
            </a-select-option>
          </a-select>
        </template>
        <template slot="site_id" slot-scope="text, record, index">
          <a-select
            style="width: 200px"
            :value="record.site_id"
            @change="value => handleChange(value, record._id, index)"
          >
            <a-select-option v-for="item in siteList" :key="item.siteid">
              {{ item.sitename }}
            </a-select-option>
          </a-select>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'id',
    dataIndex: '_id',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '公众号名称',
    dataIndex: 'channelName',
    width: '300px',
    scopedSlots: { customRender: 'channelName' },
    align: 'center'
  },
  {
    title: '所属地区',
    dataIndex: 'site_id',
    scopedSlots: { customRender: 'site_id' },
    align: 'center'
  }
];
const siteList = [
  {
    siteid: 0,
    sitename: '未分区'
  },
  {
    siteid: 2,
    sitename: '宜昌'
  },
  {
    siteid: 16,
    sitename: '西陵'
  },
  {
    siteid: 3,
    sitename: '夷陵'
  },
  {
    siteid: 18,
    sitename: '伍家'
  },
  {
    siteid: 15,
    sitename: '点军'
  },
  {
    siteid: 19,
    sitename: '猇亭'
  },
  {
    siteid: 20,
    sitename: '高新'
  },
  {
    siteid: 21,
    sitename: '宜都'
  },
  {
    siteid: 10,
    sitename: '枝江'
  },
  {
    siteid: 6,
    sitename: '当阳'
  },
  {
    siteid: 11,
    sitename: '远安'
  },
  {
    siteid: 12,
    sitename: '秭归'
  },
  {
    siteid: 13,
    sitename: '长阳'
  },
  {
    siteid: 9,
    sitename: '五峰'
  },
  {
    siteid: 14,
    sitename: '兴山'
  }
];
const headSiteList = [
  {
    siteid: -1,
    sitename: '全部'
  },
  {
    siteid: 0,
    sitename: '未分区'
  },
  {
    siteid: 2,
    sitename: '宜昌'
  },
  {
    siteid: 16,
    sitename: '西陵'
  },
  {
    siteid: 3,
    sitename: '夷陵'
  },
  {
    siteid: 18,
    sitename: '伍家'
  },
  {
    siteid: 15,
    sitename: '点军'
  },
  {
    siteid: 19,
    sitename: '猇亭'
  },
  {
    siteid: 20,
    sitename: '高新'
  },
  {
    siteid: 21,
    sitename: '宜都'
  },
  {
    siteid: 10,
    sitename: '枝江'
  },
  {
    siteid: 6,
    sitename: '当阳'
  },
  {
    siteid: 11,
    sitename: '远安'
  },
  {
    siteid: 12,
    sitename: '秭归'
  },
  {
    siteid: 13,
    sitename: '长阳'
  },
  {
    siteid: 9,
    sitename: '五峰'
  },
  {
    siteid: 14,
    sitename: '兴山'
  }
];
export default {
  components: {},
  data() {
    return {
      param: {
        page: 1,
        limit: 15,
        wxSiteId: -1,
        channelName: ''
      },
      siteList,
      headSiteList,
      columns,
      lists: [],
      loading: false,
      pagination: { pageSize: 15 }
    };
  },
  methods: {
    getList(param) {
      this.loading = true;
      this.$http
        .post('https://videoshow.ycrmt.cn/task/pull/wxchannel', param)
        .then(res => {
          const pagination = { ...this.pagination };
          if (res.data.state === 0) {
            this.lists = res.data.data.lists;
            pagination.total = res.data.data.total;
          } else {
            pagination.total = 0;
            this.lists = [];
          }
          this.loading = false;
          this.pagination = pagination;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.getList(this.param);
    },
    handleChange(value, _id, index) {
      const newData = [...this.lists];
      newData[index].site_id = value;
      this.lists = newData;
      this.edit(_id, value);
    },
    headChange(value) {
      this.param.wxSiteId = value;
      this.getList(this.param);
    },
    edit(_id, value) {
      this.$http
        .post('https://videoshow.ycrmt.cn/task/pull/wxedit', {
          _id,
          wxSiteId: value
        })
        .then(res => {
          if (res.data.state == 0) {
            this.$message.success('修改成功');
          } else {
            this.$message.error('修改失败');
          }
        });
    },
    onSerch(value, event) {
      this.param.channelName = value;
      this.param.page = 1;
      this.pagination.current = 1;
      this.getList(this.param);
    }
  },
  created() {
    this.getList(this.param);
  },
  mounted() {}
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
}
.subject {
  padding: 10px;
}
</style>
